import React from 'react';

import {
  Button,
  HStack,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverFooter,
  PopoverTrigger,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { customTheme } from 'theme';

import { User } from 'api/auth/api.pb';

interface ResetMFAButtonProps {
  user: User;
  isResetting: boolean;
  error?: string;
  onReset(user: User): Promise<boolean>;
}

// Lost-device recovery: confirm before removing another user's authenticator.
export const ResetMFAButton = ({
  user,
  isResetting,
  error,
  onReset,
}: ResetMFAButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} isLazy>
      <PopoverTrigger>
        <Button size="xs" variant="link" color={customTheme.colors.primary}>
          Reset
        </Button>
      </PopoverTrigger>
      <PopoverContent w="280px" textAlign="left">
        <PopoverArrow />
        <PopoverBody>
          <Text>
            Reset two-factor authentication for {user.username}? They will set
            up a new authenticator at next sign-in.
          </Text>
          {error && (
            <Text mt={2} color="red.500" role="alert">
              {error}
            </Text>
          )}
        </PopoverBody>
        <PopoverFooter>
          <HStack justify="flex-end">
            <Button size="sm" variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button
              size="sm"
              colorScheme="red"
              isLoading={isResetting}
              onClick={async () => {
                if (await onReset(user)) onClose();
              }}
            >
              Reset 2FA
            </Button>
          </HStack>
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  );
};
